import { SensorTypeEnum } from '@/types/sensor/sensors/common.types';
import {
  Mc2Module,
  Mc2Sector,
  Mc2SensorConfiguration,
  Mc2SensorStatusDto,
  OutputMode,
  OutputModeValueType,
} from '@/types/sensor/sensors/mc2.types';

// todo update with real value of BlastSectorDto
export interface BlastMode extends Mc2Sector {
  mode: OutputMode;
  modeId: OutputModeValueType;
}

export interface BlastConfig {
  code: string;
  configId: number;
  configName: string;
}

export type BlastModule = Mc2Module;

export interface BlastSensorConfiguration extends Mc2SensorConfiguration {
  type: SensorTypeEnum.BLAST;
  currentConfig: number | null;
  lastCheck: string;
  configs: BlastConfig[];
  modules: BlastModule[];
  modes: BlastMode[];
}

export enum SynchroModeEnum {
  GNSSIN = 0,
  TRIGIN = 1,
  BLANKING = 2,
}

export enum JammingModeEnum {
  STAND_BY = 0,
  HYBRID = 1,
  ACTIVE = 2,
}

export interface BlastModuleStatus extends Mc2SensorStatusDto {
  checking: boolean;
  incorrectAntenna: boolean;
}

export interface BlastSensorStatus extends Mc2SensorStatusDto {
  type: SensorTypeEnum.BLAST;
  selectedConfigId: number;
  selectedMode: OutputModeValueType | null;
  synchroMode: SynchroModeEnum; // isInActiveMode === SynchroModeEnum.ACTIVE
  jammingMode: JammingModeEnum;
  moduleStatuses: Record<string, BlastModuleStatus>;
  preferredConfigId?: number | null;
}
